import type {
    ContactUsForm,
    ContactUsSuccessResponse,
} from '@libs/common-node';
import { CWEA_ENDPOINTS } from '../constants';
import { cweaClient } from '../clients/api-proxy-browser-client';

export async function handleContactUs(body: ContactUsForm) {
    try {
        const url = CWEA_ENDPOINTS.customerCare.contactUs;

        const response = await cweaClient.post<
            ContactUsSuccessResponse,
            ContactUsForm
        >(`${url}`, {
            body,
        });

        // API response is null when unsuccessful, so we manually set isSuccess to false
        return response ?? { isSuccess: false };
    } catch {
        return {
            isSuccess: false,
        };
    }
}
